"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("@cdo/apps/templates/Button"));
var ai_tutor_module_scss_1 = __importDefault(require("./ai-tutor.module.scss"));
var aiTutorRedux_1 = require("@cdo/apps/aiTutor/redux/aiTutorRedux");
var AnalyticsReporter_1 = __importDefault(require("@cdo/apps/lib/util/AnalyticsReporter"));
var AnalyticsConstants_1 = require("@cdo/apps/lib/util/AnalyticsConstants");
var constants_1 = require("@cdo/apps/aiTutor/constants");
var reduxHooks_1 = require("@cdo/apps/util/reduxHooks");
// AI Tutor feature that explains to students why their code is not passing tests.
var ValidationTutor = function (levelId) {
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var sources = (0, react_redux_1.useSelector)(function (state) { return state.javalabEditor.sources; });
    var fileMetadata = (0, react_redux_1.useSelector)(function (state) {
        return state.javalabEditor.fileMetadata;
    });
    var activeTabKey = (0, react_redux_1.useSelector)(function (state) {
        return state.javalabEditor.activeTabKey;
    });
    var studentCode = sources[fileMetadata[activeTabKey]].text;
    var hasCompilationError = (0, react_redux_1.useSelector)(function (state) {
        return state.javalabEditor.hasCompilationError;
    });
    var hasRunOrTestedCode = (0, react_redux_1.useSelector)(function (state) { return state.javalab.hasRunOrTestedCode; });
    var validationPassed = (0, react_redux_1.useSelector)(function (state) { return state.javalab.validationPassed; });
    var isWaitingForAIResponse = (0, react_redux_1.useSelector)(function (state) { return state.aiTutor.isWaitingForAIResponse; });
    var aiResponse = (0, react_redux_1.useSelector)(function (state) { return state.aiTutor.aiResponse; });
    var systemPrompt = constants_1.validationSystemPrompt;
    var handleSend = function (studentCode) { return __awaiter(void 0, void 0, void 0, function () {
        var chatContext;
        return __generator(this, function (_a) {
            chatContext = {
                levelId: levelId,
                systemPrompt: systemPrompt,
                studentCode: studentCode,
            };
            dispatch((0, aiTutorRedux_1.askAITutor)(chatContext));
            AnalyticsReporter_1.default.sendEvent(AnalyticsConstants_1.EVENTS.AI_TUTOR_ASK_ABOUT_VALIDATION, {
                levelId: levelId,
            });
            return [2 /*return*/];
        });
    }); };
    var enableAskAITutor = hasRunOrTestedCode && !hasCompilationError && !validationPassed;
    return (react_1.default.createElement("div", { className: ai_tutor_module_scss_1.default.tutorContainer },
        !hasRunOrTestedCode && !validationPassed && (react_1.default.createElement("h4", null, "Test your code first and see what happens.")),
        hasRunOrTestedCode && hasCompilationError && (react_1.default.createElement("h4", null, "Uh oh! Your code has to compile successfully before we can work on passing tests.")),
        validationPassed && react_1.default.createElement("h4", null, "\uD83C\uDF89 Your tests are passing. Wahoo!"),
        enableAskAITutor && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h4", null, "Why aren't my tests passing?"),
            react_1.default.createElement(Button_1.default, { text: "Ask AI Tutor", isPending: isWaitingForAIResponse, pendingText: "waiting", onClick: function () { return handleSend(studentCode); }, disabled: !enableAskAITutor }),
            react_1.default.createElement("p", { id: "ai-response" }, aiResponse)))));
};
exports.default = ValidationTutor;
